const Settings = () => {
return <h1>Funzionalità in fase di implementazione</h1>
}

export default Settings;